import { render, staticRenderFns } from "./JobTemplatesTableTabs.vue?vue&type=template&id=f5a1d7ae&scoped=true&lang=pug"
import script from "./JobTemplatesTableTabs.vue?vue&type=script&lang=ts"
export * from "./JobTemplatesTableTabs.vue?vue&type=script&lang=ts"
import style0 from "./JobTemplatesTableTabs.vue?vue&type=style&index=0&id=f5a1d7ae&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a1d7ae",
  null
  
)

/* custom blocks */
import block0 from "./JobTemplatesTableTabs.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FJobTemplate%2FTable%2FJobTemplatesTableTabs.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports